import React from 'react'
import {noPropagate} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import ArrowSideIcon from './arrow-side.svg'
import {getStraightLinesIcons} from './subtasks-in-report'
import TopIcon from './top.svg'

export const Toggler = (props: {
  onToggle: () => void
  arrowDown: boolean
  flex?: boolean
  numberOfStraightLines?: number
  className?: string
}) => {
  return (
    <div
      onClick={e => {
        noPropagate(e)
        props.onToggle()
      }}
    >
      <div
        className={cn(
          props.className,
          'flex items-center text-main-old hover:text-action-hover'
        )}
      >
        {props.arrowDown && (
          <div className="absolute mt-4 ml-4 text-third-old">
            {props.flex ? (
              <div className={cn(props.className, 'absolute overflow-hidden')}>
                {getStraightLinesIcons(props.numberOfStraightLines)}
              </div>
            ) : (
              <TopIcon />
            )}
          </div>
        )}
        {props.onToggle && (
          <ArrowSideIcon
            className={cn(
              'transition transform ease-main',
              props.arrowDown && 'rotate-90'
            )}
          />
        )}
      </div>
    </div>
  )
}
